interface Props {
  size?: number;
}

export function LogoMark({ size = 36 }: Props) {
  return (
    <div
      className="logo-mark"
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.28,
        background: 'var(--gradient-brand)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 14px -4px rgba(45,0,247,.4)',
        flexShrink: 0,
      }}
    >
      <span
        style={{
          color: 'white',
          fontWeight: 800,
          letterSpacing: '-0.06em',
          fontSize: size * 0.42,
          lineHeight: 1,
        }}
      >
        ft
      </span>
    </div>
  );
}
